import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Personal" },
  { label: "Empleados", icon: "fas fa-address-card", color: "#10b981", bg: "#f0fdf4", href: "/Empleados", desc: "Alta de colaboradores", perm: "menu_empleados" },
  { label: "Puestos", icon: "fas fa-address-book", color: "#3b82f6", bg: "#eff6ff", href: "/Puestos", desc: "Catálogo de puestos", perm: "menu_puestos" },
];

function BotonesNominas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-users" color="#10b981" bg="#f0fdf4" title="Empleados" subtitle="Colaboradores y puestos" />
        <div className="row">
          {ITEMS.map((r, i) =>
            r.type === "section"
              ? <MenuSection key={i} title={r.label} />
              : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
          )}
        </div>
      </div>
    </>
  );
}

export default BotonesNominas;
